import {DishDetailsItem} from "@apps/dish/interfaces";

import {DateString, ResponseError} from "@globals/types/utilityTypes";

export type MenuResource = {
  menu?: Menu;
  isError: boolean;
  isLoading: boolean;
  error: ResponseError;
};

export type Menu = {
  holiday?: {
    name: string;
    note: string;
  };
  closed?: boolean;
  blackout?: boolean;
  blackout_messages?: string[];
  date?: DateString;
  location_id?: number;
  company?: string;
  id?: number;
  is_today?: boolean;
  sort_options: MenuSortOption[];
  items: {
    [key: string]: DishDetailsItem;
  };
};

export type MenuSortOption = {
  name: string;
  categories: MenuCategoryItem[];
  icon: string;
  pngIcon: string;
  empty_message: string;
};

export type MenuCategoryItem = {
  id: number;
  name: string;
  display_name: string;
  item_ids: number[];
  banner_style: 0 | 1;
  column_number?: number;
  collapsible: boolean;
  banner?: string;
  mobile_banner?: string;
  group_banner?: string;
  description?: string;
  link?: string;
  background_image: string;
  text_color?: string;
  secondary_banner?: string;
};

export enum MenuType {
  Individual = "individual",
  Invitee = "invite",
  Extras = "extra",
  Preview = "preview",
  GrabNGo = "grab_n_go",
  Brand = "brand",
}

export type CacheParams = {
  use_cache?: boolean;
  ignore_inventory?: boolean;
};

export type InviteMenuParams = CacheParams & {
  inviteKey: string;
};

export type GrabNGoMenuParams = CacheParams & {
  selectedDate: DateString;
  hubShortName: string;
  tenantSlug: string;
};

export type ExtrasMenuParams = CacheParams & {
  selectedDate: DateString;
  locationId: number;
};

export type IndividualMenuParams = CacheParams & {
  selectedDate: DateString;
};

export type PreviewMenuParams = GrabNGoMenuParams;

export type MenuParams =
  | InviteMenuParams
  | GrabNGoMenuParams
  | PreviewMenuParams
  | ExtrasMenuParams
  | IndividualMenuParams;

// additional params allow us to fetch specific menu outside of DishDetailsConfigContext;
export type UseMenuParams = MenuParams & {
  enabled?: boolean;
  menuType?: MenuType;
};

export type MenuFetcherParams = CacheParams & {
  date?: DateString;
  key?: string;
  hub?: string;
  ignore_inventory?: boolean;
  menu_type?: MenuType;
  tenant_slug?: string;
  day?: number;
  location_id?: number;
};
